window.jQuery ?= $

window.App =
	doComponents: (components, method, payload) ->
		for component in components
			component[method]?(
				$target: payload.$target
				options: @options
			)

		return this

	run: (options) ->
		# set options
		@options = options

		# for one usage or delegated events
		@globalComponents = [
			require('./components/tr-clickable')
			require('./components/share')
			require('./components/links')
			require('./components/deaf')
			require('./components/menuSide')
			require('./components/accordion')
			require('./components/btnDropdown')
			require('./components/eventActions')
			require('./components/header')
			require('./components/headerMenu')
			require('./components/tabs')
			require('./components/secondarySubmenu')
		]

		# components
		@components = [
			require('./components/matchHeight')
			require('./components/selectize')
			require('./components/cycle')
			require('./components/tooltip')
			require('./components/scrollNav')
			require('./components/scrollbar')
			require('./components/lightbox')
			# require('./components/map')

		]

		# init na dokument
		@doComponents(@globalComponents, 'init',
			$target: $(document)
		)
		@doComponents(@components, 'init',
			$target: $(document)
		)

		$(document)
			.on('ajax-init', (event) =>
				@doComponents(@components, 'init',
					$target: $(event.target)
				)
			)

		return



// WEBPACK FOOTER //
// ./src/js/app.coffee